import React from "react";

const BlogLayout = () => {
  return (
    <div style={styles.page}>
      {/* ===== Banner Section ===== */}
      <div style={styles.bannerSection}>
        <div style={styles.bannerOverlay}></div>
        <div style={styles.bannerContent}>
          <h1 style={styles.bannerTitle} className="slide-in">
            Progressive Web Applications
          </h1>
          <p style={styles.bannerText} className="slide-in">
            Unlocking Fast, Reliable, and Engaging Experiences on the Web
          </p>
        </div>
      </div>

      {/* ===== Blog Container ===== */}
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>
            Progressive Web Applications: Bridging the Gap Between Web and Mobile
          </h1>

          {/* Author & Meta */}
          <div style={styles.meta}>
            <img
              src="/images/author.jpg"
              alt="Author"
              style={styles.authorImage}
            />
            <div>
              <p style={styles.author}>By Jane Smith</p>
              <p style={styles.details}>
                <i className="far fa-calendar-alt" style={styles.iconInline}></i>{" "}
                23 Aug 2025 &nbsp; | &nbsp;
                <i className="far fa-clock" style={styles.iconInline}></i> 7 min
                read &nbsp; | &nbsp;
                <i className="far fa-eye" style={styles.iconInline}></i> 689
                Views
              </p>
            </div>
          </div>

          {/* Blog Intro */}
          <p style={styles.text}>
            <i className="fas fa-globe" style={styles.iconInline}></i>
            Progressive Web Applications (PWAs) are transforming the way users
            interact with web platforms. By combining the best of websites and
            mobile applications, PWAs deliver app-like experiences directly
            through a browser, without requiring installation from app stores.
          </p>
          <p style={styles.text}>
            <i className="fas fa-bolt" style={styles.iconInline}></i>
            Fast loading speeds, offline availability, push notifications, and
            device integration make PWAs a powerful choice for businesses looking
            to improve user engagement while reducing development costs.
          </p>

          {/* Why PWAs Matter */}
          <h2 style={styles.subheading}>Why PWAs Matter</h2>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-wifi" style={styles.iconList}></i> Work
              offline or in poor network conditions
            </li>
            <li>
              <i className="fas fa-tachometer-alt" style={styles.iconList}></i>{" "}
              Fast and responsive, even on low-end devices
            </li>
            <li>
              <i className="fas fa-download" style={styles.iconList}></i>{" "}
              Installable without app stores
            </li>
            <li>
              <i className="fas fa-bell" style={styles.iconList}></i> Improved
              user engagement with push notifications
            </li>
          </ul>

          {/* Key Features */}
          <h2 style={styles.subheading}>Key Features of Progressive Web Apps</h2>
          <p style={styles.text}>
            PWAs are built with modern web technologies and offer powerful
            features that bridge the gap between native and web experiences:
          </p>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-mobile-alt" style={styles.iconList}></i>{" "}
              Responsive design across all devices
            </li>
            <li>
              <i className="fas fa-database" style={styles.iconList}></i> Offline
              caching with Service Workers
            </li>
            <li>
              <i className="fas fa-lock" style={styles.iconList}></i> Secure by
              default with HTTPS
            </li>
            <li>
              <i className="fas fa-download" style={styles.iconList}></i>{" "}
              Lightweight and quick installation
            </li>
          </ul>

          {/* Example: PWA in E-commerce */}
          <h2 style={styles.subheading}>Example: PWA in E-commerce</h2>
          <p style={styles.text}>
            <i className="fas fa-shopping-cart" style={styles.iconInline}></i>
            E-commerce platforms adopting PWAs have seen remarkable results. For
            example, faster load times and offline browsing help customers
            continue shopping even in areas with weak connectivity. Push
            notifications re-engage users with personalized offers, boosting
            conversions significantly.
          </p>

          {/* Best Practices */}
          <h2 style={styles.subheading}>Best Practices for Building PWAs</h2>
          <p style={styles.text}>
            <i className="fas fa-lightbulb" style={styles.iconInline}></i>
            To ensure your Progressive Web App delivers maximum value, follow
            these best practices:
          </p>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-server" style={styles.iconList}></i> Use
              Service Workers for offline caching
            </li>
            <li>
              <i className="fas fa-expand-arrows-alt" style={styles.iconList}></i>{" "}
              Ensure your app is responsive on all screen sizes
            </li>
            <li>
              <i className="fas fa-lock" style={styles.iconList}></i> Implement
              HTTPS for security
            </li>
            <li>
              <i className="fas fa-bolt" style={styles.iconList}></i> Provide
              seamless navigation and fast performance
            </li>
          </ul>

          {/* Future of PWAs */}
          <h2 style={styles.subheading}>The Future of PWAs</h2>
          <p style={styles.text}>
            <i className="fas fa-rocket" style={styles.iconInline}></i>
            With major companies like Twitter, Starbucks, and Pinterest adopting
            PWAs, the future looks promising. As browsers evolve, PWAs will gain
            even more native-like capabilities, reducing the need for separate
            native apps and providing users with a unified experience.
          </p>

          {/* Conclusion */}
          <h2 style={styles.subheading}>Conclusion</h2>
          <p style={styles.text}>
            <i className="fas fa-check-circle" style={styles.iconInline}></i>
            Progressive Web Applications offer the perfect balance between web
            reach and mobile app experience. Businesses adopting PWAs can deliver
            faster, more reliable, and engaging solutions that users love. As the
            technology matures, PWAs are set to become the standard for modern web
            applications.
          </p>
        </div>
      </div>

      {/* ===== Animation CSS ===== */}
      <style>
        {`
          @keyframes slideIn {
            0% {
              opacity: 0;
              transform: translateX(-40px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }
          .slide-in {
            animation: slideIn 1.2s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  page: {
    position: "relative",
    background: "#fff",
    fontFamily: "Arial, sans-serif",
    letterSpacing: "0px",
  },
  /* ===== Banner Styles ===== */
  bannerSection: {
    position: "relative",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/PWAs-1.png')", 
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 10%",
    color: "#fff",
  },
  bannerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  bannerContent: {
    position: "relative",
    zIndex: 2,
    maxWidth: "600px",
  },
  bannerTitle: {
    fontSize: "42px",
    fontWeight: "bold",
    marginBottom: "15px",
    lineHeight: "1.3",
    letterSpacing:"0px",
    color:"white",
  },
  bannerText: {
    fontSize: "18px",
    lineHeight: "1.6",
    maxWidth: "500px",
    textAlign:"justify",
  },

  /* ===== Blog Styles ===== */
  container: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
    maxWidth: "900px",
    margin: "auto",
  },
  content: {
    flex: 1,
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "15px",
    lineHeight: "1.3",
    letterSpacing:"0px",
  },
  meta: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    gap: "12px",
  },
  authorImage: {
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  author: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "15px",
  },
  details: {
    margin: 0,
    fontSize: "14px",
    color: "#666",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#333",
    marginBottom: "15px",
    textAlign: "justify",
  },
  subheading: {
    fontSize: "22px",
    fontWeight: "600",
    marginTop: "25px",
    marginBottom: "12px",
    letterSpacing:"0px",
  },
  list: {
    paddingLeft: "0px",
    marginBottom: "20px",
    listStyle: "none",
  },
  iconList: {
    marginRight: "8px",
    color: "#007bff",
  },
  iconInline: {
    marginRight: "6px",
    color: "#007bff",
  },

  /* ===== Responsive ===== */
  "@media (max-width: 768px)": {
    bannerTitle: {
      fontSize: "28px",
    },
    bannerText: {
      fontSize: "16px",
    },
    title: {
      fontSize: "26px",
    },
  },
};

export default BlogLayout;
